import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';

import { queryClient } from '~app/query-client';
import { KEYS } from '~shared/api/query-keys';
import { baseAPI } from '~shared/api/base-api';

interface SquareConnectParams {
  studioId?: string;
  locationId?: string;
}

interface SquareConnectResponse {
  url: string;
}

/** V2 Square OAuth — start Connect for the authenticated studio. */
export const getSquareConnectUrl = async (
  params: SquareConnectParams = {},
): Promise<SquareConnectResponse> => {
  const response = await baseAPI.get<SquareConnectResponse>(
    '/v2/onboarding/square/connect',
    { params },
  );
  return response.data;
};

/** V2 Square OAuth — revoke token and clear Square credential fields only. */
export const disconnectSquareConnect = async (): Promise<void> => {
  await baseAPI.delete('/v2/onboarding/square');
};

export const useDisconnectSquareConnectMutation = () => {
  return useMutation({
    mutationFn: disconnectSquareConnect,
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: [KEYS.STRIPE, KEYS.CREDENTIALS],
      });
      void queryClient.invalidateQueries({
        queryKey: [KEYS.STUDIO_DEFAULT_PAYMENT_PROVIDER],
      });
      toast.success('Square integration removed');
    },
    onError: () => {
      toast.error('Failed to remove Square integration');
    },
  });
};
